import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleAll(event) {
    const checkbox = event.target
    const allCheckboxes = this.element.querySelectorAll('input[name="customer_ids[]"]')

    allCheckboxes.forEach(box => {
      box.checked = checkbox.checked
    })
  }

  toggleItem() {
    const allCheckboxes = this.element.querySelectorAll('input[name="customer_ids[]"]')
    const checkedCount = Array.from(allCheckboxes).filter(box => box.checked).length
    const selectAllCheckbox = this.element.querySelector('thead input[type="checkbox"]')

    // Update "select all" checkbox state
    selectAllCheckbox.checked = checkedCount === allCheckboxes.length
    selectAllCheckbox.indeterminate = checkedCount > 0 && checkedCount < allCheckboxes.length
  }
}